import { render, staticRenderFns } from "./OverdueSuccessPayment.vue?vue&type=template&id=71b10a40&"
import script from "./OverdueSuccessPayment.vue?vue&type=script&lang=js&"
export * from "./OverdueSuccessPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports